import ExternalLink from './ExternalLinks';

export default ExternalLink;
